import { type TFunction } from 'i18next';

export const format = (t: TFunction, key: string, value: number | undefined) =>
  Number.isFinite(value) ? t(key, { value }) : t('common:number.na');
